export default "__VITE_ASSET__CeZRNph$__"